
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freshwater-algae",
      function () {
        return require("private-next-pages/freshwater-algae/index.js");
      }
    ]);
  